'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ImgUtils = require('../util/img');
var Logger = require('../util/logger');
var CanIUse = require('../util/caniuse');
var Util = require('../util/index');

var mutaRecords = []; // 记录 mutation 新增节点及其对应时间
var domTimer = null; // DOM 变化监听计时器
var perfTimer = null; // 资源请求监听计时器
var domDone = false; // DOM 变化监听结束标记
var perfDone = false; // 资源请求监听结束标记
var senseTime = void 0; // 存放 FST 和 FCP 时间
var FCP = -1; // 模拟的 first contentful paint 时间
var ignoreFirstScreenImg = void 0; // 是否忽略首屏内图片的加载
var outCount = 0; // 记录检测到首屏外 mutation 的次数
var scrollDom = void 0;

var MaxOutCount = 15; // 检测到首屏外 mutation 次数阈值
var STOPTIME = 3000; // 默认的停止监听超时阈值
var MinScore = 3; // 有效 DOM 变更的最小权重阈值
var ELEMENT_WEIGHT = 1; // 元素权重的基本权重
var DEP_WEIGHT = 0; // 元素权重的深度权重
var NodesFilter = ['HTML', 'HEAD', 'META', 'LINK', 'SCRIPT', 'STYLE', 'NOSCRIPT']; // 非视觉元素

var ArraySlice = Array.prototype.slice;
var parseInt = Number.parseInt || window.parseInt;
var windowSize = getViewportSize();
var windowHeight = windowSize.height;
var windowWidth = windowSize.width;
var NAME = 'page';

var FirstScreenManager = function () {
    function FirstScreenManager(cfgManager, pageManager) {
        _classCallCheck(this, FirstScreenManager);

        this.cfgManager = cfgManager;
        this.pageManager = pageManager;
        this.pageData = [];
        this.observer = null;
        this.disableMutaObserver = false;
        var pageCfg = cfgManager.get(NAME);
        var mutaStopTime = parseInt(pageCfg.mutaStopTime || 0);
        this.mutaStopTime = mutaStopTime > STOPTIME ? mutaStopTime : STOPTIME;
        this.perfObserver = null;
        this.ignoreDom = pageCfg.ignoreAttr || 'owl-ignore';
        this.imgPattern = /(\.)(png|jpg|jpeg|gif|webp|ico|bmp|tiff|svg)/i;
        this.noCheckOuterMutaCount = pageCfg.noCheckOuterMutaCount;
        this.canStartObserver = CanIUse.PerformanceNow() && CanIUse.MutationObserver();
        this.spaRoutesData = {};
        scrollDom = pageCfg.scrollDom;
        if (window._Owl_) {
            this.pageData = window._Owl_.pageData;
            this.observer = window._Owl_.observer;
            this.disableMutaObserver = window._Owl_.disableMutaObserver;
        }
        // 要求算法开始前body已存在, 新的observer能以body作为目标, 取代document来缩小监听范围
        if (this.disableMutaObserver || !document.body) {
            domDone = true;
            perfDone = true;
            try {
                this.observer && this.observer.disconnect();
            } catch (e) {}
        }
    }
    /**
     * 配置 DOM 变化和资源请求的监听及回调
     *
     * @memberof FirstScreenManager
     */


    _createClass(FirstScreenManager, [{
        key: 'mutaObserver',
        value: function mutaObserver() {
            var _this = this;

            if (!this.canStartObserver || domDone) return;

            if (this.observer && this.observer.disconnect) {
                // 关闭预采集模块中创建的observer并处理之前记录的mutation
                try {
                    this.observer.disconnect();
                    this.observer = null;
                    if (this.pageData && this.pageData.length) {
                        this.pageData.forEach(function (item) {
                            _this.mutaCallback(item.mutations, item.startTime, false);
                        });
                        // clear this.pageData
                    }
                } catch (e) {
                    console.log('observer disconnect err');
                }
            }

            var pageConfig = this.cfgManager.get(NAME);
            try {
                // 创建新的observer, 以body为目标来缩小监听范围
                this.observer = new MutationObserver(function (mutations) {
                    var time = performance.now();
                    _this.mutaCallback(mutations, time, true);
                });
                this.observer.observe(document.body, {
                    childList: true,
                    subtree: true
                });
                this.resetTimer(true);

                // 页面加载完成之后, 响应用户交互来停止DOM变化监听
                if (pageConfig.interactToStopObserver === true && document && document.addEventListener) {
                    if (document.readyState === 'complete') {
                        this.interactToStopObserver();
                    } else {
                        var ADD_EVENT = window.addEventListener || window.attachEvent;
                        ADD_EVENT('load', function () {
                            _this.interactToStopObserver();
                        });
                    }
                }
            } catch (e) {
                console.log('observer observe err');
            }

            // 忽略首屏内图片的加载请求
            ignoreFirstScreenImg = pageConfig.disableSensoryImageIndex;
            perfDone = ignoreFirstScreenImg || perfDone;
            if (!perfDone) {
                this.registerPerfObserver();
            }
        }
        /**
         * 开启资源请求的监听
         *
         * @memberof FirstScreenManager
         */

    }, {
        key: 'registerPerfObserver',
        value: function registerPerfObserver() {
            var _this2 = this;

            var disablePerfObserver = this.cfgManager.get('resource').disablePerformanceObserver || false;
            if (CanIUse.PerformanceObserver() && disablePerfObserver !== true) {
                // 8s图片监听超时时间, 防止perfDone不会变成true, 导致无法进入最终的回调
                var perTimer = setTimeout(function () {
                    _this2.perfObserverStop();
                }, 8000);
                this.perfObserver = new window.PerformanceObserver(function () {
                    clearTimeout(perfTimer);
                    perfTimer = setTimeout(function () {
                        clearTimeout(perTimer);
                        _this2.perfObserverStop();
                    }, STOPTIME);
                });
                this.perfObserver.observe({ entryTypes: ['resource'] });
            } else {
                perfDone = true;
            }
        }
    }, {
        key: 'getSensoryIndex',
        value: function getSensoryIndex(callback) {
            var _this3 = this;

            var doneTimer = 0;
            // 8s超时监听, 防止无法执行callback并导致不上报测速点
            var fstTimer = setTimeout(function () {
                clearInterval(doneTimer);
                _this3.mutaObserverStop();
                _this3.perfObserverStop();
                callback(senseTime);
            }, 8000);

            var getSense = function getSense() {
                if (domDone && perfDone) {
                    clearInterval(doneTimer);
                    clearTimeout(fstTimer);
                    if (senseTime) {
                        if (!ignoreFirstScreenImg) {
                            caculateImageTiming(_this3.ignoreDom, _this3.imgPattern);
                        }
                        callback(senseTime);
                    } else {
                        callback();
                    }
                }
            };
            doneTimer = setInterval(getSense, 500);
        }
    }, {
        key: 'resetTimer',
        value: function resetTimer(newTimer) {
            var _this4 = this;

            if (domTimer) clearTimeout(domTimer);

            if (newTimer) {
                domTimer = setTimeout(function () {
                    Logger.logScreen(_this4.mutaStopTime + 'ms\u65F6\u95F4\u5185\u6CA1\u6709\u76D1\u542C\u5230\u65B0\u7684DOM\u53D8\u5316, \u505C\u6B62DOM\u53D8\u5316\u76D1\u542C');
                    _this4.mutaObserverStop();
                }, this.mutaStopTime);
            }
        }
        /*
        * mutation 回调: 记录变更时间和元素集合, 存储到 mutaRecords, 用于 FST 的计算
        * @param mutations
        * @param startTime
        * @param reset 是否重置计时器
        */

    }, {
        key: 'mutaCallback',
        value: function mutaCallback(mutations, startTime, reset) {
            var _this5 = this;

            if (reset) this.resetTimer(true);
            startTime = startTime || performance.now();

            // 为什么要用那么多个setTimeout？是否形成了多个闭包从而影响了性能？
            setTimeout(function () {
                // 已达到停止DOM变化监听的条件后, 不再处理还未处理的mutations
                if (domDone) return;

                Logger.logScreen('DOM原始变更:', startTime, mutations);
                // 筛选有效的MutationRecord
                mutations.filter(function (mutation) {
                    var targetNodeName = (mutation.target.nodeName || '').toUpperCase();
                    return mutation.type === 'childList' && targetNodeName && NodesFilter.indexOf(targetNodeName) < 0 && mutation.addedNodes && mutation.addedNodes.length;
                }).forEach(function (mutation) {
                    if (domDone) return;

                    // 筛选有效的新增节点
                    var addedNodes = ArraySlice.call(mutation.addedNodes, 0).filter(function (node) {
                        var nodeName = (node.nodeName || '').toUpperCase();
                        return node.nodeType === 1 // 忽略非元素节点
                        && nodeName && NodesFilter.indexOf(nodeName) < 0 // 忽略非视觉元素
                        && nodeName !== 'IFRAME' // 忽略iframe
                        && node.isConnected !== false // 忽略未挂载至DOM树的元素
                        && !shouldIgnoreNode(node, _this5.ignoreDom); // 忽略业务手动配置的元素
                    });
                    if (!(addedNodes && addedNodes.length && addedNodes[0])) return;

                    // 记录筛选后的新增节点及其对应时间, 用于之后FST的计算
                    mutaRecords.push({
                        nodes: addedNodes,
                        startTime: startTime
                    });

                    var firstNode = addedNodes[0];
                    // 模拟白屏时间 FCP - first contentful paint
                    if (FCP < 0) {
                        calcuFCP(firstNode, startTime);
                    }

                    // 检测到有效的首屏外mutation的次数达到阈值时, 停止DOM变化监听
                    // 此处的rect可以记录下来供后面使用, 减少getBoundingClientRect的执行次数(important)
                    try {
                        if (!_this5.noCheckOuterMutaCount) {
                            var rect = firstNode.getBoundingClientRect && firstNode.getBoundingClientRect();
                            if (rect && rect.width && rect.height && rect.top >= windowHeight) {
                                // 此处的判断逻辑是否应该加强？
                                Logger.logScreen('\u68C0\u6D4B\u5230\u9996\u5C4F\u5916\u8282\u70B9\u6B21\u6570: ' + ++outCount + '\u6B21, \u8282\u70B9\u5185\u5BB9\u4E3A:', addedNodes);
                                if (outCount >= MaxOutCount) {
                                    Logger.logScreen('\u68C0\u6D4B\u5230\u9996\u5C4F\u5916mutation\u8FBE\u5230 ' + MaxOutCount + ' \u6B21, \u505C\u6B62DOM\u53D8\u5316\u76D1\u542C');
                                    _this5.mutaObserverStop();
                                }
                            }
                        }
                    } catch (e) {
                        Util.reportSysWarn(e);
                    }

                    // 支持自定义响应用户交互后停止DOM变化监听
                    if (document && document.querySelectorAll) {
                        addedNodes.forEach(function (node) {
                            _this5.addEventToStopObserver(node);
                        });
                    }
                });
            }, 0);
        }
        /**
         * 关闭MutationObserver, 并开始进行计算
         *
         * @memberof FirstScreenManager
         */

    }, {
        key: 'mutaObserverStop',
        value: function mutaObserverStop() {
            if (this.observer && this.observer.disconnect) {
                try {
                    this.observer.disconnect();
                    this.observer = null;

                    var config = this.cfgManager.get(NAME);
                    markMeasure(config.sensoryIndex || config.manualReportFST);

                    this.resetTimer(false);
                } catch (e) {
                    console.log('observer disconnect err');
                }
            }
        }
    }, {
        key: 'perfObserverStop',
        value: function perfObserverStop() {
            try {
                if (this.perfObserver && this.perfObserver.disconnect) {
                    this.perfObserver.disconnect();
                    this.perfObserver = null;
                }
                perfDone = true;
            } catch (e) {
                console.log('perfObserver disconnect err');
            }
        }
        // 支持业务自定义响应用户交互以停止DOM变化监听

    }, {
        key: 'addEventToStopObserver',
        value: function addEventToStopObserver(node) {
            var _this6 = this;

            ArraySlice.call(node.querySelectorAll('[interactive]'), 0).forEach(function (eventNode) {
                var type = eventNode.getAttribute('interactive') || 'click';
                var callback = function callback() {
                    _this6.mutaObserverStop();
                    eventNode.removeEventListener(type, callback);
                };
                eventNode.addEventListener(type, callback);
            });
        }
        // 全局响应用户交互以停止DOM变化监听

    }, {
        key: 'interactToStopObserver',
        value: function interactToStopObserver() {
            var _this7 = this;

            if (domDone) return;

            var callback = function callback() {
                if (domDone) {
                    removeListener();
                    return;
                }

                Logger.logScreen('onload后响应到用户交互事件, 停止DOM变化监听');
                _this7.mutaObserverStop();
                removeListener();
            };

            var removeListener = function removeListener() {
                document.removeEventListener('click', callback);
                document.removeEventListener('wheel', callback);
                document.removeEventListener('touchmove', callback);
            };

            document.addEventListener('click', callback);
            document.addEventListener('wheel', callback);
            document.addEventListener('touchmove', callback);
        }
    }, {
        key: 'startRouteMutaObserver',
        value: function startRouteMutaObserver(path) {
            var _this8 = this;

            if (!domDone || !this.canStartObserver || !document.body) return;

            // 初始化路由页面的首屏计算信息
            var start = performance.now();
            var routeInfo = {
                start: start,
                pageUrl: '',
                observer: null,
                mutaRecords: [],
                domTimer: null,
                domDone: false,
                outCount: 0,
                fst: 0,
                interactCallback: null
            };
            this.spaRoutesData[path] = routeInfo;
            Logger.logScreen('[' + path + '] ' + start + ' \u65F6\u523B\u5F00\u59CB\u9996\u5C4F\u8BA1\u7B97');

            try {
                routeInfo.observer = new MutationObserver(function (mutations) {
                    _this8.routeMutaCallback(path, mutations);
                });
                routeInfo.observer.observe(document.body, {
                    childList: true,
                    subtree: true
                });
                this.resetRouteTimer(path, true);
                setTimeout(function () {
                    _this8.interactToStopRouteObserver(path);
                }, 0);
            } catch (e) {}
        }
    }, {
        key: 'stopRouteMutaObserver',
        value: function stopRouteMutaObserver(prevPath) {
            var routeInfo = this.spaRoutesData[prevPath];
            if (routeInfo && !routeInfo.domDone) {
                // 上一页面尚未停止 DOM 变化的监听
                routeInfo.domDone = true;
                this.removeRouteInteractListener(prevPath);
                this.resetRouteTimer(prevPath, false);
                routeInfo.observer.disconnect();
                routeInfo.observer = null;
            }
        }
    }, {
        key: 'resetRouteTimer',
        value: function resetRouteTimer(path, newTimer) {
            var _this9 = this;

            var routeInfo = this.spaRoutesData[path];
            if (routeInfo) {
                routeInfo.domTimer && clearTimeout(routeInfo.domTimer);
                if (newTimer) {
                    routeInfo.domTimer = setTimeout(function () {
                        Logger.logScreen('[' + path + '] ' + _this9.mutaStopTime + 'ms\u5185\u65E0\u65B0\u7684DOM\u53D8\u5316, \u505C\u6B62\u76D1\u542C');
                        _this9.routeMutaStop(path);
                    }, this.mutaStopTime);
                } else {
                    routeInfo.domTimer = null;
                }
            }
        }
    }, {
        key: 'routeMutaCallback',
        value: function routeMutaCallback(path, mutations) {
            var _this10 = this;

            var routeInfo = this.spaRoutesData[path];
            if (!routeInfo || routeInfo.domDone) return;

            var startTime = performance.now();
            this.resetRouteTimer(path, true);

            Logger.logScreen('[' + path + '] DOM\u53D8\u5316\u539F\u59CB\u5185\u5BB9: ', startTime, mutations);
            mutations.filter(function (mutation) {
                var targetNodeName = (mutation.target.nodeName || '').toUpperCase();
                return mutation.type === 'childList' && targetNodeName && NodesFilter.indexOf(targetNodeName) < 0 && mutation.addedNodes && mutation.addedNodes.length;
            }).forEach(function (mutation) {
                if (!routeInfo || routeInfo.domDone) return;

                var addedNodes = ArraySlice.call(mutation.addedNodes, 0).filter(function (node) {
                    var nodeName = (node.nodeName || '').toUpperCase();
                    return node.nodeType === 1 && nodeName && NodesFilter.indexOf(nodeName) < 0 && nodeName != 'IFRAME' && node.isConnected !== false && !shouldIgnoreNode(node, _this10.ignoreDom);
                });
                if (!(addedNodes && addedNodes.length && addedNodes[0])) return;

                routeInfo.mutaRecords.push({
                    nodes: addedNodes,
                    startTime: startTime
                });

                try {
                    var rect = addedNodes[0].getBoundingClientRect();
                    if (rect && rect.width && rect.height && rect.top >= windowHeight) {
                        Logger.logScreen('[' + path + '] \u68C0\u6D4B\u5230\u9996\u5C4F\u5916mutation ' + ++routeInfo.outCount + '\u6B21: ', addedNodes);
                        if (routeInfo.outCount >= MaxOutCount) {
                            Logger.logScreen('[' + path + '] \u68C0\u6D4B\u5230\u9996\u5C4F\u5916mutation\u8FBE\u5230 ' + MaxOutCount + '\u6B21, \u505C\u6B62\u76D1\u542C');
                            _this10.routeMutaStop(path);
                        }
                    }
                } catch (e) {}
            });
        }
    }, {
        key: 'routeMutaStop',
        value: function routeMutaStop(path) {
            try {
                var routeInfo = this.spaRoutesData[path];
                if (!routeInfo || routeInfo.domDone) return;

                routeInfo.domDone = true;
                routeInfo.observer && routeInfo.observer.disconnect();
                routeInfo.observer = null;
                this.removeRouteInteractListener(path);
                this.resetRouteTimer(path, false);

                var validRecords = [];
                Logger.logScreen('[' + path + '] \u7B5B\u9009\u540E\u7684\u6709\u6548DOM\u53D8\u5316: ', routeInfo.mutaRecords);
                routeInfo.mutaRecords.forEach(function (_ref) {
                    var nodes = _ref.nodes,
                        startTime = _ref.startTime;

                    var validNodes = [];
                    nodes.forEach(function (node) {
                        var _ref2 = node.style || {},
                            visibility = _ref2.visibility,
                            display = _ref2.display;

                        if (visibility != 'hidden' && display != 'none') {
                            var rect = node.getBoundingClientRect && node.getBoundingClientRect();
                            if (inViewPort(rect)) {
                                validNodes.push({ node: node, rect: rect });
                            }
                        }
                    });
                    if (validNodes.length) {
                        var score = calScore(validNodes);
                        if (score) {
                            validRecords.push({ score: score, startTime: startTime, validNodes: validNodes });
                            Logger.logScreen('[' + path + '] \u6709\u6548\u7684\u9996\u5C4F\u65B0\u589E\u8282\u70B9, \u6743\u91CD\u53CA\u65F6\u523B: ', validNodes, score, startTime);
                        }
                    }
                });
                routeInfo.mutaRecords = [];

                var routeFstEnd = getFST(validRecords, path);
                var result = parseInt(routeFstEnd - routeInfo.start);
                Logger.logScreen('[' + path + '] DOM\u9996\u5C4F\u65F6\u95F4\u7684\u8BA1\u7B97\u7ED3\u679C\u4E3A: ' + result);
                if (result > 0) {
                    routeInfo.fst = result;
                    routeInfo.pageUrl = this.cfgManager.get('pageUrl');
                    this.pageManager.reportRouteFst(result, routeInfo.pageUrl);
                }
            } catch (e) {}
        }
    }, {
        key: 'removeRouteInteractListener',
        value: function removeRouteInteractListener(path) {
            var routeInfo = this.spaRoutesData[path];
            if (!routeInfo || !routeInfo.interactCallback) return;

            document.removeEventListener('click', routeInfo.interactCallback);
            document.removeEventListener('wheel', routeInfo.interactCallback);
            document.removeEventListener('touchmove', routeInfo.interactCallback);
        }
    }, {
        key: 'interactToStopRouteObserver',
        value: function interactToStopRouteObserver(path) {
            var _this11 = this;

            var routeInfo = this.spaRoutesData[path];
            if (!routeInfo || routeInfo.domDone) return;

            routeInfo.interactCallback = function () {
                Logger.logScreen('[' + path + '] \u54CD\u5E94\u5230\u7528\u6237\u4EA4\u4E92\u4E8B\u4EF6, \u505C\u6B62\u76D1\u542C');
                _this11.routeMutaStop(path);
            };
            document.addEventListener('click', routeInfo.interactCallback);
            document.addEventListener('wheel', routeInfo.interactCallback);
            document.addEventListener('touchmove', routeInfo.interactCallback);
        }
    }]);

    return FirstScreenManager;
}();

// 视口viewport尺寸计算


function getViewportSize() {
    return {
        height: window.innerHeight || 0,
        width: window.innerWidth || 0
    };
}

// 使用HTML标签属性自定义忽略一些元素
function shouldIgnoreNode(node, ignoreDom) {
    var ignore = false;
    if (ignoreDom) {
        ignore = !!(node.closest && node.closest('[' + ignoreDom + ']')) || node.hasAttribute && node.hasAttribute(ignoreDom);
    }
    if (ignore) {
        Logger.logScreen('自定义忽略元素: ', node);
    }
    return ignore;
}

// 模拟计算首次内容绘制时间
function calcuFCP(node, time) {
    // 浏览器支持Paint Timing时模拟时间置为0
    if (performance && performance.getEntriesByType && performance.getEntriesByType('paint') && document && document.body && document.body.innerText !== '') {
        FCP = 0;
    } else if (node && (node.nodeType === 3 || node.innerText !== '') || document.querySelector && document.querySelector('img')) {
        FCP = parseInt(time || 0);
    }
}

function markMeasure(fstFlag) {
    if (domDone) return;
    calcuFST(fstFlag);
}

function calcuFST(flag) {
    var validRecords = [];
    if (flag) {
        Logger.logScreen('\u7B5B\u9009\u540E\u7684\u6709\u6548DOM\u53D8\u66F4:', mutaRecords);
        mutaRecords.forEach(function (_ref3) {
            var nodes = _ref3.nodes,
                startTime = _ref3.startTime;

            var validNodes = [];
            nodes.forEach(function (node) {
                // 筛选首屏内可见节点
                var _ref4 = node.style || {},
                    visibility = _ref4.visibility,
                    display = _ref4.display;

                if (visibility !== 'hidden' && display !== 'none') {
                    var rect = node.getBoundingClientRect && node.getBoundingClientRect(); // [text]元素无此方法
                    if (inViewPort(rect)) {
                        validNodes.push({ node: node, rect: rect });
                    }
                }
            });
            if (validNodes.length) {
                var score = calScore(validNodes);
                if (score) {
                    validRecords.push({ score: score, startTime: startTime, validNodes: validNodes });
                    Logger.logScreen('\u6709\u6548\u7684\u9996\u5C4F\u5185\u65B0\u589E\u8282\u70B9:', validNodes, '\u65B0\u589E\u8282\u70B9\u7684\u6743\u91CD\u548C\u53D1\u751F\u65F6\u95F4:', score, startTime);
                }
            }
        });
    }

    domDone = true;
    mutaRecords = [];
    var FST = getFST(validRecords);
    senseTime = { FST: FST, FCP: FCP || 0 };
    Logger.logScreen('最终DOM首屏时间的计算结果为: ', FST);
}

// 判断节点是否在视口范围内
function inViewPort(rect) {
    var _ref5 = rect || {},
        width = _ref5.width,
        height = _ref5.height,
        top = _ref5.top,
        right = _ref5.right,
        bottom = _ref5.bottom,
        left = _ref5.left;
    // 节点在视口外的条件: 节点和视口无重合区域


    return width > 0 && height > 0 && bottom > 0 && top < windowHeight && right > 0 && left < windowWidth;
}

// 计算新增节点的权重和
function calScore(wrapedNodes) {
    return wrapedNodes.reduce(function (score, it) {
        return score + depScore(it, 0);
    }, 0);
}

// 遍历子节点计算权重 (深度优先)
function depScore(wrapedNode, dep) {
    // 优先使用缓存数据
    var node = wrapedNode.node,
        rect = wrapedNode.rect;

    var _ref6 = node.style || {},
        visibility = _ref6.visibility,
        display = _ref6.display;

    // 1.隐藏元素直接返回


    if (visibility === 'hidden' || display === 'none') return 0;

    // 2.文本元素: 首字符非回车换行 (浏览器注入较多空白文本元素)
    if (node.nodeType === 3) {
        if (node.textContent) {
            var firstChar = node.textContent.charCodeAt(0);
            if (firstChar !== 10 && firstChar !== 13) {
                return dep + ELEMENT_WEIGHT;
            }
        }
        return 0;
    }

    // 3.遍历子元素: 若子元素均不可见则退化为叶节点
    if (node.childNodes && node.childNodes.length) {
        var subScore = ArraySlice.call(node.childNodes, 0).reduce(function (score, node) {
            return score + depScore({ node: node }, dep + DEP_WEIGHT);
        }, 0);
        if (subScore > 0) return subScore + ELEMENT_WEIGHT;
    }

    // 4.叶节点

    var _ref7 = rect || { width: node.clientWidth, height: node.clientHeight },
        width = _ref7.width,
        height = _ref7.height;

    return width > 0 && height > 0 ? dep + ELEMENT_WEIGHT : 0;
}

// 选取权重大于阈值的最后一次变更
function getFST(records, routePath) {
    if (!(records && records.length)) return 0;

    // 合并同时或紧邻的两次记录 (startTime差小于1)
    var batchRecords = records.reduce(function (tempArr, current) {
        var prev = tempArr[tempArr.length - 1];
        if (prev && current.startTime - prev.startTime < 1) {
            prev.score += current.score;
        } else {
            tempArr.push({ score: current.score, startTime: current.startTime, nodes: current.validNodes });
        }
        return tempArr;
    }, []);
    Logger.logScreen('合并后的首屏新增节点权重记录:', batchRecords);

    // 选择最后一次有效的首屏内DOM变更记录 (最后一次新增节点权重大于阈值3的变更)
    var bestMatch = batchRecords.reduce(function (prev, current) {
        return !prev || current.score > Math.min(prev.score, MinScore) ? current : prev;
    }, null);
    var result = parseInt(bestMatch && bestMatch.startTime || 0);

    if (!routePath && window.Owl && bestMatch) {
        window.Owl.fstInfo = {
            domFST: result,
            decisiveNode: bestMatch.nodes && bestMatch.nodes[0] ? bestMatch.nodes[0].node : ''
        };
    }

    return result;
}

function caculateImageTiming(ignoreTag, imgPattern) {
    var inScreenImgTimes = ImgUtils.getImageTimingsInFirstScreen(ignoreTag, imgPattern, scrollDom);
    if (senseTime && inScreenImgTimes.length) {
        var imageFST = Math.round(inScreenImgTimes[0]);
        senseTime.FST = Math.max(senseTime.FST, imageFST);
        Logger.logScreen('首屏图片时间: ', imageFST);
        Logger.logScreen('最终首屏时间: ', senseTime.FST);
        if (window.Owl && window.Owl.fstInfo) {
            window.Owl.fstInfo.imgFST = imageFST;
        }
    }
}

module.exports = FirstScreenManager;